import i18n from "i18n/config";

export const CAPITAL_AMOUNT_FIELD = "capital_amount";
export const FUND_FAMILY_FILTER = "fund_family__name";

export const STUB_CALCULATION = {
  id: "sum" as const,
  name: i18n.t("views:stubCalc"),
};
